import { Component, OnInit, AfterContentInit, AfterContentChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { prebootComplete } from "angular2-universal";
import { ConfigService } from '../shared/config.service';
import { IntlService } from '../shared/intl.service';
import { UtilsService } from '../shared/utils.service';

@Component({
    template: require('./partials/page-not-found.html'),
})
export class PageNotFoundComponent implements OnInit, AfterContentInit, AfterContentChecked {

    public currentLanguage: string;

    constructor(public utils: UtilsService, public intl: IntlService, private config: ConfigService, private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit(){
        // Current language
        this.route.parent.params.subscribe(
            (params: Params) => { this.currentLanguage = params['lg'] }
        );
    }

    ngAfterContentInit() {
        if (typeof prebootComplete != 'undefined') {
            prebootComplete();
        }
    }

    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }     
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/page-not-found.component.ts